import { Group, Pagination, Select, Skeleton, Stack, Title } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useTracks } from '~/api/queries'
import { TrackTable } from '~/components/blocks/TrackTable/TrackTable'

export const Route = createFileRoute('/_app/tracks/')({
  component: TracksPage,
})

const sortOptions = [
  { value: 'alphabetical', label: 'A-Z' },
  { value: 'newest', label: 'Newest' },
  { value: 'random', label: 'Random' },
]

function TracksPage() {
  const [page, setPage] = useState(1)
  const [sort, setSort] = useState('alphabetical')
  const limit = 50
  const { data, isLoading } = useTracks({ sort, limit, offset: (page - 1) * limit })

  const totalPages = data ? Math.ceil(data.total / limit) : 0

  return (
    <Stack gap="md">
      <Group justify="space-between">
        <Title order={2}>Tracks</Title>
        <Select
          data={sortOptions}
          value={sort}
          onChange={(v) => {
            setSort(v || 'alphabetical')
            setPage(1)
          }}
          w={180}
        />
      </Group>

      {isLoading ? <Skeleton h={400} /> : data?.data ? <TrackTable tracks={data.data} /> : null}

      {totalPages > 1 && (
        <Group justify="center">
          <Pagination value={page} onChange={setPage} total={totalPages} />
        </Group>
      )}
    </Stack>
  )
}
